/* eslint-disable max-lines-per-function */
import {
  Button,
  Command,
  CommandGroup,
  CommandItem,
  CommandSeparator,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  ScrollArea,
} from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarStar,
  faCog,
  faPlusLarge,
} from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { CalendarSelectCommandItemValues } from '@/domain/termine/features/Calendar/shared/CalendarSelectCommandItemValues';
import { Link } from 'react-router-dom';

export function CalendarSelect() {
  const { t } = useTranslation();
  const { kalender, selectedKalenderIds, setSelectedKalenderIds } =
    useCalendarContext();

  function handleSelect(kalenderId: string) {
    if (selectedKalenderIds.includes(kalenderId)) {
      setSelectedKalenderIds(
        selectedKalenderIds.filter((id) => id !== kalenderId),
      );
    } else {
      setSelectedKalenderIds([...selectedKalenderIds, kalenderId]);
    }
  }

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button variant="subtle" size="icon">
          <FontAwesomeIcon icon={faCalendarStar} />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="flex flex-col">
        <DrawerHeader className="pb-0">
          <DrawerTitle className="text-sm text-center text-neutrals-900 font-semibold">
            {t('domain.termine.terminCalendar')}
          </DrawerTitle>
          <DrawerDescription className="sr-only">
            {t('domain.termine.terminCalendar')}
          </DrawerDescription>
        </DrawerHeader>
        <div className="flex-1 px-4" data-vaul-no-drag>
          <ScrollArea className="overflow-scroll max-h-[60vh]">
            <Command>
              <CommandGroup>
                {kalender.length > 1 &&
                  kalender.map((kalenderItem) => (
                    <CommandItem
                      className="transition-colors text-sm font-normal"
                      key={kalenderItem.id}
                      value={kalenderItem.name}
                      onSelect={() => handleSelect(kalenderItem.id)}>
                      <CalendarSelectCommandItemValues
                        kalenderItem={kalenderItem}
                        selectedKalenderIds={selectedKalenderIds}
                      />
                    </CommandItem>
                  ))}
                {kalender.length > 1 && <CommandSeparator className="my-1" />}
                <CommandItem
                  asChild
                  className="transition-colors text-sm flex items-center gap-2 p-2 rounded-sm font-semibold">
                  <Link to="/termine/kalender/uebersicht">
                    <FontAwesomeIcon
                      icon={kalender.length > 0 ? faCog : faPlusLarge}
                      className="h-4 w-4 text-primary-blue-600"
                    />
                    <span className="text-primary-blue-600">
                      {kalender.length > 0
                        ? t('domain.termine.manageTerminCalendar')
                        : t('domain.termine.createTerminCalendar')}
                    </span>
                  </Link>
                </CommandItem>
              </CommandGroup>
            </Command>
          </ScrollArea>
        </div>
        <div className="p-4 shrink-0">
          <DrawerClose asChild>
            <Button className="w-full" size="lg">
              {t('domain.termine.form.fertig')}
            </Button>
          </DrawerClose>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
